// extracted by mini-css-extract-plugin
export default {"custom-themes":"CustomizedThemeTab_custom-themes__o3+4f","title":"CustomizedThemeTab_title__ci+Hx"};